import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postReviewList } from "../../api/customerCenter";
import { toast } from "wc-toast";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import moment from "moment";

function Review() {
  const access_token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const [reviewList, setReviewList] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [option, setOption] = useState({
    order_str: "regDate",
    searchStr: "",
  });

  useEffect(() => {
    // console.log("reviewList:", reviewList);
  }, []);

  const callReviewList = async (option) => {
    const data = {
      order_str: option.order_str,
      searchStr: option.searchStr,
      // startIdx: 0,
      // rowCnt: 5,
    }
    try {
      const response = await postReviewList(data);
    
      if (response?.code === 1000) {
        setReviewList(response?.resultList);
      } else {
        return console.log("이용후기 불러오는데 실패했습니다.");
      }
    } catch (err) {
      return console.log("이용후기 불러오는데 실패했습니다.");
    }
  };

  useEffect(() => {
    if (access_token) {
      callReviewList(option);
    } else {
      toast.error("로그인이 필요합니다.");
    }
  }, [access_token, option]);

  const handleItemClick = async (order) => {
    setOption({ ...option, order_str: order });
  };

  const handleInputChange = async (e) => {
    setSearchString(e.target.value);
  };
 


  return (
    <div className="customer-service">
      <div className="pageBreadcrumb d-flex justify-content-end gap-3 mb-3" style={{position: 'relative'}}>
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle variant="light" id="dropdown-split-basic">
            {option?.order_str === "cCnt"
              ? "댓글 많은 순"
              : option?.order_str === "hitCnt"
              ? "조회 많은 순"
              : "최신 등록순"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleItemClick('regDate')} href="#">
              최신 등록순
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleItemClick('hitCnt')} href="#">
              조회 많은 순
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleItemClick('cCnt')} href="#">
              댓글 많은 순
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <input
          type="text"
          className="btn-search-input ps-2 w-200px w-sm-180px"
          name={"searchStr"}
          placeholder="제목/작성자 검색"
          value={searchString?.trim()}
          onChange={handleInputChange}
        />
        <button
          type="button"
          className="btn-search-click" 
          onClick={() => {
            if (searchString.length !== 1) {
              setOption({ ...option, searchStr: searchString})
            } else {
              toast.error("2자 이상 입력해주세요")
            }
          }}
        >
          {/* <img src={process.env.PUBLIC_URL + "/img/SearchIcon.svg"}/> */}
        </button>
      </div>
      {reviewList?.length > 0 ? (
        <div className="list-container">
          <ul className="responsive-list border-top-1">
            {reviewList?.map((item, index) => {
              return (
                <li className="list-item" key={index}>
                  <span
                    className="text"
                    onClick={() => navigate(`/review/${item.review_seq}/view`)}
                    style={{ cursor: "pointer" }}
                  >
                    {item?.title}
                  </span>
                  <span className="date">
                    {item.user_nm} / {item.reg_dt} / 조회{" "}{item.hit_cnt} / 댓글{" "}{item.cCnt}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div className="mypage_wrapper ">
          <div className="container">
            <div className="card_part">
              <div className="card_box intrestCard d-flex align-items-center py-3 justify-content-center">
                이용후기가 없습니다.
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-end"
      >
        <button onClick={() => { if(!access_token) return; navigate('/review/new') }} 
         className="btn Table_Btn w-100px"
        >    
          글쓰기
        </button>
      </div>
    </div>
  );
}

export default Review;
